/**
 * /admin/mcp — MCP(위임 접근) 연동·호출 기록 조회 (조회 전용)
 *
 * 부모 `/admin` 라우트가 인증 가드와 `AdminLayout` 을 맡는다. UI 는 `McpAccessPage`.
 * 탭·보기·필터·페이지를 전부 URL search 에 실어 사고 대응 결과를 링크로 공유하고 새로고침해도 유지한다
 * (계약: `features/admin/mcp/search.ts`). 서버 계약: backend/src/v2/delegated_access/monitor_router.py
 */
import { createFileRoute } from '@tanstack/react-router'

import { McpAccessPage } from '@/features/admin/mcp/McpAccessPage'
import type { McpSearch } from '@/features/admin/mcp/search'
import { validateMcpSearch } from '@/features/admin/mcp/search'

export const Route = createFileRoute('/admin/mcp')({
  component: AdminMcpPage,
  validateSearch: validateMcpSearch,
})

function AdminMcpPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  // patch 의 undefined 키는 URL 에서 빠진다 — 기본값으로 돌아간다는 뜻
  const onSearchChange = (patch: Partial<McpSearch>) => {
    navigate({ search: (prev: McpSearch) => ({ ...prev, ...patch }) })
  }
  return <McpAccessPage search={search} onSearchChange={onSearchChange} />
}
